import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import compose from 'recompose/compose';

import { updateLayer } from '../../../actions'
import { COPPER, CORE, PREPREG } from '../../../constants/globals';
import Material from '../../../models/Material';
import {
  getStackupLayer,
  getStackupLayers,
  getMirrorLayer,
  getLengthUnit,
} from '../../../reducers';
import EditLayerComponent from './EditLayerComponent';
import NotFoundDialog from './NotFoundDialog';

function valuesToCopper(values) {
  return values;
}

function valuesToCore(values) {
  return values;
}

function valuesToPrepreg(values) {
  return values;
}

function valuesToLayer(type, values) {
  switch(type){
    case COPPER:
      return valuesToCopper(values);
    case CORE:
      return valuesToCore(values);
    case PREPREG:
      return valuesToPrepreg(values);
    default:
      return values;
  }
}

export class EditLayerContainer extends Component {
  constructor(props) {
    super(props);
    this.onClose = this.onClose.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }
  onClose() {
    const { history } = this.props;
    const { from } = (history.location && history.location.state) || {};
    if (from) {
      history.push(from);
    } else {
      history.push('/app');
    }
  }

  onSubmit(values) {
    const { layer, mirror, updateLayer } = this.props;
    const { applyMirror, ...rest } = values;
    const newLayer = valuesToLayer(layer.type, rest);
    updateLayer(layer.index, newLayer);

    if (applyMirror && layer.type === mirror.type) {
      const newMirror = valuesToLayer(mirror.type, rest);
      newMirror.name = mirror.name;

      updateLayer(mirror.index, newMirror);
    }
    this.onClose();
  }

  render() {
    const { layer, mirror, layers, lengthUnit } = this.props;
    if (layer === undefined) {
      return <NotFoundDialog onClose={this.onClose} />;
    }

    return (
      <EditLayerComponent
        onSubmit={this.onSubmit}
        onCancel={this.onClose}
        layer={layer}
        layers={layers}
        mirror={mirror}
        lengthUnit={lengthUnit}
      />
    );
  }
}

function mapStateToProps(state, props) {
  const { match } = props;
  const key = match.params.key;
  const layer = getStackupLayer(state, key);
  const layers = getStackupLayers(state);
  const mirror = getMirrorLayer(state, layer.index);
  const lengthUnit = getLengthUnit(state);

  return { layer, layers, mirror, lengthUnit };
}

const mapDispatchToProps = { updateLayer };

EditLayerContainer.propTypes = {
  // Props from stateToProps
  layer:       PropTypes.instanceOf(Material).isRequired,
  layers:      PropTypes.arrayOf(PropTypes.instanceOf(Material)).isRequired,
  mirror:      PropTypes.instanceOf(Material).isRequired,
  lengthUnit:  PropTypes.string.isRequired,

  // Props from withRouter
  history:     ReactRouterPropTypes.history.isRequired,

  // props from dispatchToProps
  updateLayer: PropTypes.func.isRequired,
};

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(EditLayerContainer);



// WEBPACK FOOTER //
// ./src/components/StackupDesign/EditLayer/EditLayerContainer.js